import { render, staticRenderFns } from "./JDictSelectTag.vue?vue&type=template&id=28cd5a7e&scoped=true"
import script from "./JDictSelectTag.vue?vue&type=script&lang=js"
export * from "./JDictSelectTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd5a7e",
  null
  
)

export default component.exports